import {
  Divider,
  FormControl,
  FormGroup,
  Grid,
  RadioGroup,
  TextField,
} from "@mui/material";

import FilterLabel from "./utils/FilterLabel";
import RadioLabel from "./utils/RadioLabel";
import StyledRadio from "./utils/StyledRadio";
import CheckboxHelper from "./utils/CheckboxHelper";
import CheckboxLabel from "./utils/CheckboxLabel";
import StyledCheckbox from "./utils/StyledCheckbox";
import FilterController from "./utils/FilterController";

const GpiFilters = ({ values, errors, handleChange, setValues }) => {
  const allStatusesSelected = values.gpiStatuses.includes("ALL");
  return (
    <>
      <Grid item>
        <FormControl margin="dense" fullWidth>
          <FilterLabel sx={{ fontSize: 16 }}>GPI/UC</FilterLabel>
        </FormControl>
      </Grid>
      <Grid item>
        <Grid container>
          <Grid item xs={2}>
            <FilterController label="UETR" error={errors.uetr}>
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.uetr}
                value={values.uetr}
                onChange={handleChange}
                name="uetr"
              />
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <FilterController label="" error={errors.gpiStatuses}>
          <FormGroup
            row
            onChange={(e) => {
              setValues({
                ...values,
                gpiStatuses: e.target.checked
                  ? [...values.gpiStatuses, e.target.value]
                  : values.gpiStatuses.filter(
                      (item) => item !== e.target.value
                    ),
              });
            }}
          >
            <Grid container>
              <Grid item xs={1.5}>
                <CheckboxLabel
                  value="ALL"
                  control={<StyledCheckbox />}
                  label="All"
                  checked={values.gpiStatuses.includes("ALL")}
                />
                <CheckboxHelper>All Status</CheckboxHelper>
              </Grid>
              <Grid item xs={2}>
                <CheckboxLabel
                  value="ACSP"
                  control={<StyledCheckbox />}
                  label="ACSP"
                  checked={values.gpiStatuses.includes("ACSP") || allStatusesSelected}
                  disabled={allStatusesSelected}
                />
                <CheckboxHelper>
                  Settlement In Progress, Pending Status
                </CheckboxHelper>
              </Grid>
              <Grid item xs={2}>
                <CheckboxLabel
                  value="ACCC"
                  control={<StyledCheckbox />}
                  label="ACCC"
                  checked={values.gpiStatuses.includes("ACCC") || allStatusesSelected}
                  disabled={allStatusesSelected}
                />
                <CheckboxHelper>
                  Settlement Completed, <br></br>Final Status
                </CheckboxHelper>
              </Grid>
              <Grid item xs={2}>
                <CheckboxLabel
                  value="RJCT"
                  control={<StyledCheckbox />}
                  label="RJCT"
                  checked={values.gpiStatuses.includes("RJCT") || allStatusesSelected}
                  disabled={allStatusesSelected}
                />
                <CheckboxHelper>
                  Payment Rejected, <br></br>Final Status
                </CheckboxHelper>
              </Grid>
            </Grid>
          </FormGroup>
        </FilterController>
      </Grid>
{/*       <Grid item>
        <FormControl margin="dense" fullWidth>
          <FilterLabel sx={{ fontSize: 16 }}>Agent</FilterLabel>
        </FormControl>
      </Grid>
      <Grid item>
        <Grid container>
          <Grid item xs={2}>
            <FilterController label="BIC" error={errors.agentBic}>
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.agentBic}
                value={values.agentBic}
                onChange={handleChange}
                name="agentBic"
              />
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <FilterController label="" error={errors.agentType}>
          <RadioGroup
            row
            value={values.agentType}
            onChange={handleChange}
            name="agentType"
          >
            <RadioLabel value="ALL" control={<StyledRadio />} label="All" />
            <RadioLabel
              value="INSTRUCTED"
              control={<StyledRadio />}
              label="Instructed Agent"
            />
            <RadioLabel
              value="INSTRUCTING"
              control={<StyledRadio />}
              label="Instructing Agent"
            />
            <RadioLabel
              value="INTERMEDIARY"
              control={<StyledRadio />}
              label="Intermediary Agent"
            />
          </RadioGroup>
        </FilterController>
      </Grid> */}
      <Grid item>
        <Divider />
      </Grid>
    </>
  );
};

export default GpiFilters;
